import React, { useEffect, useState } from "react";
import ProfileForm from "./ProfileForm";
import { Modal } from 'react-bootstrap';
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

function Logout() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [sorteos, setSorteos] = useState([]);
  const [selectedSorteo, setSelectedSorteo] = useState("");
  const [showProfileModal, setShowProfileModal] = useState(false);


  useEffect(() => {
    fetchSorteos();

    // Ya no se usa setUserRole, el rol viene de auth
  }, [auth.id]);

  const fetchSorteos = async () => {
    try {
      const response = await axios.get("https://us-central1-inprojuy-f1173.cloudfunctions.net/app/sorteos");
      setSorteos(response.data);
    } catch (error) {
      console.error("Error al obtener los sorteos:", error);
    }
  };

  const handleSorteoChange = (event) => {
    setSelectedSorteo(event.target.value);
  };

  const navigateToConsultarCupones = () => {
    if (selectedSorteo) {
      navigate(`/cupones/${auth.id}/${selectedSorteo}`);
    }
  };



  return (
    <div className="">
      <center>
        <h1 className="botonbordeazul text-white px-5 mx-5 py-3 h1">
          Perfil de Usuario
        </h1>
      </center>

      <div className="animate-pulse" style={{ maxWidth: 420, margin: '0 auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #0001', padding: 18 }}>
        <table className="table table-borderless mb-0" style={{ fontSize: 18 }}>
          <tbody>
            <tr>
              <th className="text-end" style={{ width: 120 }}>E-mail:</th>
              <td className="text-start">{auth.user}</td>
            </tr>
            <tr>
              <th className="text-end">Usuario:</th>
              <td className="text-start">{auth.userName}</td>
            </tr>
            <tr>
              <th className="text-end">Rol:</th>
              <td className="text-start"><span className="badge bg-primary" style={{ fontSize: 16 }}>{auth.realRole || auth.role}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />

      <div className="mt-3 text-center">
        <button className="btn btn-info px-4 py-2" onClick={() => setShowProfileModal(true)}>
          Editar
        </button>
      </div>
      <Modal show={showProfileModal} onHide={() => setShowProfileModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Perfil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProfileForm />
        </Modal.Body>
      </Modal>
      <p></p>

     {/*  <form>
        <div style={{ border: '1px solid #000', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', padding: '10px', borderRadius: '5px' }}>
          <h3>Consulta de Cupones no Ganadores cargados</h3>

          <select value={selectedSorteo} onChange={handleSorteoChange}>
            <option value="">Seleccione sorteo</option>
            {sorteos.map((sorteo) => (
              <option key={sorteo.n_sorte} value={sorteo.n_sorte}>
                {sorteo.n_sorte} - {sorteo.mes}
              </option>
            ))}
          </select>
          <div style={{ width: '10px' }} />
          <button
            disabled={!selectedSorteo}
            onClick={navigateToConsultarCupones}
          >
            <>Consultar Cupones</>
          </button>
        </div>
      </form> */}
      <br />

      <div></div>
    
    </div>
  );
}

export default Logout;
